import { Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { TemplatesCodeModal } from "./TemplatesCodeModal";
import style from "./template.module.css";

import { ReactComponent as InfoIcon } from "images/info.svg";
import { OfferCodesModal } from "./OfferTemplate/OfferCodesModal";

export const TemplatesCodeBtn = observer(({ type, isOffer }: { type?: string; isOffer?: boolean }) => {
  const { actionModals } = useStores();

  const handleOpenModal = () => {
    actionModals.open(() => (!isOffer ? <TemplatesCodeModal type={type ?? ""} /> : <OfferCodesModal />), {
      width: "700px",
      noValidation: true,
      isOverlayClose: false,
    });
  };

  return (
    <Tooltip title="Список кодов для шаблона">
      <button onClick={handleOpenModal} className={`${style.templateCodesBtn}`}>
        <InfoIcon />
      </button>
    </Tooltip>
  );
});
